<template>
    <div class="experience_login">
        <div class="login">
            <div class="big_title">财税实训平台</div>
            <div class="login_title">登录</div>
            <el-form ref="loginFormRef" size="large" :model="loginForm" :rules="loginRules">
                <el-form-item prop="mobile">
                    <el-input style="width: 290px;" maxlength="11" v-model="loginForm.mobile" placeholder="请输入手机号">
                    <template #prefix>
                        <el-icon class="el-input__icon">
                            <user />
                        </el-icon>
                    </template>
                    </el-input>
                </el-form-item>
                <el-form-item prop="code">
                    <div class="code">
                        <el-input style="width: 190px;" v-model="loginForm.code"  placeholder="图形验证码">
                            <template #prefix>
                                <el-icon class="el-input__icon"><Bell /></el-icon>
                            </template>
                        </el-input>
                        <div class="code_main" @click="getImgCode">
                            <img :src="`data:image/png;base64,${base64Img}`" alt="">
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="smsCode">
                    <el-input style="width: 290px;" v-model="loginForm.smsCode"  placeholder="短信验证码">
                            <template #prefix>
                                <el-icon class="el-input__icon">
                                    <lock />
                                </el-icon>
                            </template>
                            <template #suffix>
                                <el-button type="primary" link @click="getMsgCode">获取短信验证码</el-button>
                            </template>
                    </el-input>
                </el-form-item>
                <el-form-item >
                    <div class="login-btn">
                        <el-button type="primary" :loading="loading" @click="login(loginFormRef)">
                            登录
                        </el-button>
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script setup>
import useUserStore from '@/store/modules/user'
import {setToken} from "@/utils/auth";
import { JSEncrypt } from 'jsencrypt'
import { ElMessage } from 'element-plus'
import { getImgCodeApi,getPublicKeyApi,sendMobileCodeApi,loginV2BySMSApi } from '@/api/experience/index'
const loginForm = reactive({
    mobile: "",
    codeKey: "",
    code:"",
    smsCode:""
})
const base64Img = ref('')
const loading = ref(false)
const loginFormRef = ref()
const loginRules = reactive({
    mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
    smsCode: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }],
    code: [{ required: true, message: '请输入图形验证码', trigger: 'blur' }],
})
const encryptParams = (params) =>{
    let decrypt = new JSEncrypt()
    decrypt.setPrivateKey(publicKey.value);
    const encryptedData = decrypt.encrypt(params)
    return encryptedData
}
const router = useRouter()
const login = (formEl) =>{
    if (!formEl) return
    formEl.validate(async (valid) => {
        if (valid) {
            loading.value = true
            const params = JSON.stringify(toRaw(loginForm))
            const encryptedData = encryptParams(params)
            try {
                const res = await loginV2BySMSApi({encryptedData})
                if(res.code == 200){
                    ElMessage.success('登录成功')
                    setToken(res.data['access_token'])
                    useUserStore().setToken(res.data['access_token'])
                    await useUserStore().getInfo()
                    router.push({
                        path: '/experience/cssc',
                    });
                    loading.value = false;
                }else{
                    loading.value = false;
                }
            } catch (error) {
                loading.value = false;
            }
        } else {
            console.log('error submit!')
        }
    })
}
const getImgCode = async () =>{
    const res = await getImgCodeApi()
    if(res.code == 200){
        loginForm.codeKey = res.data.codeKey;
        base64Img.value = res.data.image
    }else{
        ElMessage.error('获取图片验证码失败')
    }
}
const publicKey = ref('')
const getPublicKey = async ()=>{
    const res = await getPublicKeyApi();
    if(res.code == 200){
        publicKey.value = res.data;
    }
    
}
const getMsgCode = async ()=>{
    const params = JSON.stringify({
        mobile:loginForm.mobile,
        codeKey:loginForm.codeKey,
        code:loginForm.code
    })
    const encryptedData = encryptParams(params)
    const res = await sendMobileCodeApi({encryptedData});
    if(res.code == 200){
        ElMessage.success('发送成功')
    }
}
getImgCode()
getPublicKey()
</script>

<style lang="scss" scoped>
.experience_login{
    width: 100%;
    height: 100%;
    background-image: url('@/assets/images/exp-login.png');
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .login{
        display: flex;
        width: 410px;
        padding: 40px 60px;
        box-sizing: border-box;
        flex-direction: column;
        align-items: center;
        gap: 30px;
        border-radius: 8px;
        background: #FFF;
        position: relative;
        .big_title{
            width: 410px;
            color: #ffffff;
            text-align: center;
            text-shadow: 0 4px 4px #00000026;
            font-size: 48px;
            font-style: normal;
            font-weight: 900;
            position: absolute;
            left: 0;
            top:-100px;
        }
        .login_title{
            color: #333333;
            text-align: center;
            font-size: 22px;
        }
        .code{
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 290px;
            .code_main{
                display: flex;
                width: 90px;
                height: 40px;
                align-items: center;
                border-radius: 4px;
                justify-content: center;
                background: #E2E6ED;
                box-sizing: border-box;
                cursor: pointer;
                img{
                    display: block;
                    width: 80px;
                    height: 32px;
                }
            }

        }
        .login-btn{
            .el-button{
                width: 290px;
            }
        }
    }
}
</style>